import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';
import { Heading, PageHeader, PageSection, PageShell, Text } from '@/components/system';
import { getArticlesByTopic } from './articles';
import { HelpBreadcrumb } from './components/HelpBreadcrumb';
import { HELP_TOPICS } from './data/help-content';

export default function HelpTopicPage() {
    const { topicId } = useParams();
    const topic = HELP_TOPICS.find((item) => item.id === topicId);

    if (!topic) {
        return <Navigate to="/help" replace />;
    }

    const articles = getArticlesByTopic(topic.id);

    return (
        <PageShell width="default">
            <HelpBreadcrumb
                items={[{ label: 'Central de ajuda', to: '/help' }, { label: topic.title }]}
            />

            <PageHeader title={topic.title} subtitle={topic.description} icon={topic.icon} />

            <PageSection
                title="Guias disponíveis"
                description={`${articles.length} guia${articles.length === 1 ? '' : 's'} sobre ${topic.title.toLowerCase()}.`}
                contentClassName="p-3 sm:p-4"
            >
                <div className="flex flex-col gap-2">
                    {articles.map((article) => (
                        <Link
                            key={article.slug}
                            to={`/help/${topic.id}/${article.slug}`}
                            className="group flex items-start gap-4 rounded-xl border border-transparent p-3 transition-[background-color,border-color] duration-150 ease-out hover:border-border/80 hover:bg-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:p-4"
                        >
                            <div className="min-w-0 flex-1 space-y-1">
                                <Heading as="h3" variant="card" className="text-brand">
                                    {article.title}
                                </Heading>
                                <Text variant="description">{article.description}</Text>
                            </div>
                            <ArrowRight className="mt-1.5 size-4 shrink-0 text-muted-foreground transition-[color,transform] duration-150 ease-out group-hover:translate-x-0.5 group-hover:text-foreground" />
                        </Link>
                    ))}
                </div>
            </PageSection>
        </PageShell>
    );
}
